export default {
    methods: {
        cloneData(inputData){
            return JSON.parse(JSON.stringify(inputData));
        }
    }
}
